<template>
	<inertia-head title="Bo Sanchez FREE Webinar" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Thank you
					</h1>
					<h2 class="fw-bold text-white mb-2">
						Unlock Financial Freedom
					</h2>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Watch the Truly Rich Club Roadmap to Financial Success webinar below.
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row justify-content-center">
			<div class="col-sm-12 col-md-10 col-lg-8">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="embed-responsive embed-responsive-16by9 xl-p-bottom webinar-video">
							<iframe class="embed-responsive-item" src="https://player.vimeo.com/video/973697186" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';

	export default{
		layout: GuestLayout,
	}
</script>

<style scoped>
	.webinar-video {
		position: relative;
		width: 100%;
		padding-top: 56.25%;
		overflow: hidden;
		background: #000;
	}

	.webinar-video iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
</style>
